<template>
  <CCard class="my-4">
    <CContainer v-if="isLoadingData" class="d-flex justify-content-center my-5">
      <CSpinner style="width: 60px; height: 60px" />
    </CContainer>
    <div v-else>
      <div v-if="headerData">
        <div class="d-flex px-5 pt-5 pb-4 justify-content-between align-items-center border-bottom">
          <span class="font-3xl font-weight-bold">{{ headerData.name || '-' }}</span>
          <div class="d-flex align-items-center gap-10">
            <div>
              <span class="font-weight-bold">{{ $t('automation.statistics.header.code') }}:</span>
              <span> {{ headerData.code || '-' }}</span>
            </div>
            <CopyAction :copyReference="headerData.code" />
          </div>
        </div>
        <div class="d-flex mw-500 justify-content-between align-items-center px-5 p-4">
          <div class="d-flex flex-column">
            <span class="font-weight-bold text-uppercase">{{ $t('automation.statistics.header.metadata.lastUpdate') }}</span>
            <span>{{ headerDataLastUpdate || '-' }}</span>
          </div>
          <div class="d-flex flex-column">
            <span class="font-weight-bold text-uppercase">{{ $t('automation.statistics.header.metadata.trigger') }}</span>
            <span>{{ headerDataTrigger || '-' }}</span>
          </div>
          <div class="d-flex flex-column">
            <span class="font-weight-bold text-uppercase">{{ $t('automation.statistics.header.metadata.status') }}</span>
            <span>{{ headerDataStatus || '-' }}</span>
          </div>
        </div>
      </div>
      <div v-else class="py-4 d-flex justify-content-center">
        <EmptyMessage />
      </div>
    </div>
  </CCard>
</template>
<script>
import CopyAction from '@/components/CopyAction.vue'
import { dateFormat, getUserDateFormat } from '@/utils/dateUtil.js'
import { TRIGGER_TYPES, STATE_TYPES } from '../constants'
import EmptyList from '@/components/EmptyList.vue'
import EmptyMessage from '@/components/EmptyMessage.vue'

export default {
  name: 'AutomationStatisticsHeader',
  components: { CopyAction, EmptyList, EmptyMessage },
  props: {
    headerData: {
      type: Object,
      default: () => ({}),
    },
    isLoadingData: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userSelectedFormat() {
      return this.$store.state.auth.user.dateTimeFormat
    },
    headerDataLastUpdate() {
      if (!this.headerData?.lastUpdate) return
      const lastUpdateDateTime = dateFormat(this.headerData.lastUpdate)

      return lastUpdateDateTime.toFormat(getUserDateFormat(this.userSelectedFormat))
    },
    headerDataTrigger() {
      //TODO: Futuramente lidar com múltiplos triggers
      const triggerType = this.headerData?.triggerTypes?.[0].type

      switch (triggerType) {
        case TRIGGER_TYPES.DATE:
          return this.$t('automation.statistics.header.trigger-type.date')
        default:
          return ''
      }
    },
    headerDataStatus() {
      const stateType = this.headerData?.state

      switch (stateType) {
        case STATE_TYPES.ENABLED:
          return this.$t('automation.statistics.header.state-type.active')
        case STATE_TYPES.DRAFT:
          return this.$t('automation.statistics.header.state-type.draft')
        case STATE_TYPES.DISABLED:
          return this.$t('automation.statistics.header.state-type.inactive')
        default:
          return ''
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.gap-10 {
  gap: 10px;
}
.gap-40 {
  gap: 40px;
}
.mw-500 {
  max-width: 500px;
}
</style>
